import { z } from 'zod';
import { bestProductTypeMap } from '../../../../features/ProductList/type';
import { CoerceToBooleanSchema } from '../../../../shared/schema/boolean';
import { bestProductTypeSchema } from '../../../../features/ProductList/validate/best_product';

const rankingSchema = z.object({
  rank_type: bestProductTypeSchema,

  /**
   * 선택한 중카테고리, `undefined`이면 전체 카테고리임
   */
  cate_list_id: z.coerce.number().optional(),

  /**
   * 품절 상품 제외
   */
  exclude_sold_out: CoerceToBooleanSchema.optional(),
});

export type ProductRankingQueryParams = z.infer<typeof rankingSchema>;

const DefaultQueryParams: ProductRankingQueryParams = {
  rank_type: bestProductTypeMap.realtime,
};

export const validateRankType = (rank_type: unknown) => {
  const { data, success } = bestProductTypeSchema.safeParse(rank_type);

  if (success) {
    return data;
  } else {
    return 'realtime';
  }
};

export const validateRankingQueryParams = (query: unknown): ProductRankingQueryParams => {
  const parsed = rankingSchema.safeParse(query);

  if (parsed.success) {
    return parsed.data;
  } else {
    return DefaultQueryParams;
  }
};
